module.exports = __webpack_public_path__ + "img/neutral.3d94488f.png";